import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { checkboxPrefixCls } from "@/base/components/checkbox/Checkbox.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Checkbox">> = ({
  colorHoverBgContainer,
  colorBgActiveDisabled,
  colorCheckBgDisabled,
  colorBorderIndeterminate,
  sizeIndeterminate,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${checkboxPrefixCls}-wrapper`]: {
      [`&:hover`]: {
        [`.${checkboxPrefixCls}:not(.${checkboxPrefixCls}-disabled):not(.${checkboxPrefixCls}-checked)`]:
          {
            [`.${checkboxPrefixCls}-inner`]: {
              backgroundColor: colorHoverBgContainer,
            },
          },
      },
      [`.${checkboxPrefixCls}`]: {
        [`&.${checkboxPrefixCls}-indeterminate`]: {
          [`.${checkboxPrefixCls}-inner`]: {
            borderColor: `${colorBorderIndeterminate} !important`,
            [`&:after`]: {
              width: sizeIndeterminate,
              height: sizeIndeterminate,
              borderRadius: 2,
            },
          },
        },
        [`&.${checkboxPrefixCls}-disabled.${checkboxPrefixCls}-checked`]: {
          [`.${checkboxPrefixCls}-inner`]: {
            borderColor: colorBgActiveDisabled,
            backgroundColor: colorBgActiveDisabled,
            [`&::after`]: {
              borderColor: colorCheckBgDisabled,
            },
          },
        },
      },
    },
  },
});

export const useCheckboxStyle = genComponentStyleHook(
  ["Checkbox", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
